import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class TasksService {

    constructor(private readonly http: HttpClient) { }

    replicateDirectory(sourcePath: string, destinationPath: string) {
        return this.http.get<string>(`${environment.apiUrl}${environment.versionApi}/tasks/replicate-directory?sourcePath=${sourcePath}&destinationPath=${destinationPath}`);
    }

    replicateCostumer(sourcePath: string, sourceLabel: string, destinationPath: string) {
        return this.http.get<string>(`${environment.apiUrl}${environment.versionApi}/tasks/replicate-costumer?sourcePath=${sourcePath}&sourceLabel=${sourceLabel}&destinationPath=${destinationPath}`);
    }

}